<template>
  <confirmation-modal modalId="log-out" :confirmationAction="logout">
    <template slot="header">
      <h4 class="modal-title mb-0">{{ _T('Logging Out') }}</h4>
    </template>
    <template slot="body">
      <h6>{{ _T('Do you really want to logout?') }}</h6>
    </template>
  </confirmation-modal>
</template>

<script>
import ConfirmationModal from './ConfirmationModal'
import { mapGetters } from 'vuex'
export default {
  name: 'ConfirmLogout',
  components: {
    ConfirmationModal,
  },
  computed: {
    ...mapGetters(['_T']),
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
      this.$bvModal.hide('log-out')
      this.$router.push({ name: 'home' }).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped></style>
